<template>
  <q-card class="col-12 q-mt-md">
    <q-card-section>
      <div class="col-12 row flex">
        <div class="col-8 row">
          <label class="label-contract"
            >{{ data.codeCity }} - {{ data.contractNumber }}</label
          >
        </div>
        <!-- <div class="col-4 row flex justify-end">
          <label class="label-hours">{{ data.conclusionTime }}</label>
        </div> -->
      </div>
      <div class="col-12 row flex">
        <div class="col-6 row">
          <label class="label-date"
            >{{ data.city }} <br />
            {{ data.conclusionTime }}</label
          >
        </div>
        <div class="col-6 row flex justify-end">
          <div
            class="card-status-geral flex justify-center items-center text-center q-pa-sm"
            :class="'status-' + data.codeStatus"
          >
            <label>{{ data.contractStatus }}</label>
          </div>
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
export default {
  name: "CardServiceHistory",
  props: {
    data: Object,
  },
};
</script>

<style scoped lang="scss">
label {
  font-family: Roboto;
  font-style: normal;
}

.status-1 {
  background-color: #caebed;
}
.status-2 {
  background-color: #e0e0e0;
}
.status-3 {
  background-color: #dcd3e4;
}
.status-4 {
  background-color: #e5f6e3;
}
.status-5 {
  background-color: #e5f6e3;
}
.status-7 {
  background-color: #e5f6e3;
}

.label-contract {
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
}

.label-hours {
  font-weight: 900;
  font-size: 14px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.4);
}

.label-date {
  padding: 3% 0%;
  font-weight: 900;
  font-size: 12px;
  line-height: 14px;
  color: rgba(0, 0, 0, 0.4);
}

.card-status-geral {
  width: 100%;

  label {
    font-weight: bold;
    font-size: 12px;
    line-height: 14px;
    color: rgba(0, 0, 0, 0.6);
  }
}
</style>
